import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/move';

/** 状況 `move_enter`（組み立ては `../fx/move.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'move_enter', role: 'effect', ...spec }, 'move_enter_effect.js');
